export const ZERO = 0;
export const ONE = 1;

export const optionsFrequency = {
    MONTHLY: 'Monthly',
    HOURLY: 'Hourly',
    WEEKLY: 'Weekly',
    EVERY2WEEKS: 'Every2Weeks',
    BIMONTHLY: 'BiMonthly',
    ANNUAL: 'Annual',
};

export interface IProps {
    handlerChangeItems?: Function;
    incomeError?: boolean;
    isDisabled?: boolean;
    initialIncomes?: any;
    isEditMode: boolean;
    setFieldValueUpdated: Function;
}
